/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AufenthaltInputs */

const de__field_aufenthalt = /** @type {(inputs: _Field_AufenthaltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufenthalt`)
};

/**

* @param {_Field_AufenthaltInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_aufenthalt = /** @type {((inputs?: _Field_AufenthaltInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AufenthaltInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_aufenthalt(inputs)
});